// components/ProtectedRoute.tsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isLoggedIn, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!loading && !isLoggedIn) {
            navigate('/login', {
                state: {
                    from: location.pathname,
                    message: 'Por favor inicia sesión para acceder a esta página'
                }
            });
        }
    }, [isLoggedIn, loading, navigate, location]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
                    <div className="text-sm text-gray-600">Cargando...</div>
                </div>
            </div>
        );
    }

    return isLoggedIn ? <>{children}</> : null;
};

export default ProtectedRoute;